import { useContext } from 'react';

import NotificationContext from '@zen/Components/NotificationProvider/NotificationContext';

export const useNotification = () => useContext(NotificationContext);
